"use strict";
// Don't rename these unless you track down all instances of their use cases.
// Use the CRUD format for naming - keep items categorized.
// Insert into DB via (`name`, `category`, `display`).
//               `createPads`, `general`, `Make a new pad.`
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = exports.Access = void 0;
var Access;
(function (Access) {
    // General
    Access["CreatePads"] = "CreatePads";
    Access["ReadPads"] = "ReadPads";
    Access["ReadSettings"] = "ReadSettings";
    Access["ReadAssetApprovals"] = "ReadAssetApprovals";
    Access["UpdatePermissions"] = "UpdatePermissions";
    Access["UpdateTitleSite"] = "UpdateTitleSite";
    Access["ReadNewDispense"] = "ReadNewDispense";
    // Dashboard
    Access["CreateAlerts"] = "CreateAlerts";
    Access["ReadDashboard"] = "ReadDashboard";
    Access["ReadAlerts"] = "ReadAlerts";
    Access["ReadApprovedAssetsAlerts"] = "ReadApprovedAssetsAlerts";
    Access["ViewAlertsWidget"] = "ViewAlertsWidget";
    Access["ViewDispenseWidget"] = "ViewDispenseWidget";
    Access["ViewPadWidget"] = "ViewPadWidget";
    Access["ViewClaimsWidget"] = "ViewClaimsWidget";
    Access["ViewPharmacyWidget"] = "ViewPharmacyWidget";
    Access["ViewProviderWidget"] = "ViewProviderWidget";
    Access["ViewFinancialWidget"] = "ViewFinancialWidget";
    Access["ViewPharmaciesFinancialWidget"] = "ViewPharmaciesFinancialWidget";
    Access["ViewPaymentWidget"] = "ViewPaymentWidget";
    Access["ViewIntentWidget"] = "ViewIntentWidget";
    // Claims
    Access["CreateClaims"] = "CreateClaims";
    Access["ReadClaims"] = "ReadClaims";
    Access["ReadFailures"] = "ReadFailures";
    Access["ReadErrors"] = "ReadErrors";
    Access["ReadResponses"] = "ReadResponses";
    Access["ReadPrint"] = "ReadPrint";
    Access["ReadAudit"] = "ReadAudit";
    Access["ReadProfit"] = "ReadProfit";
    Access["ReadCopay"] = "ReadCopay";
    Access["ReadQueue"] = "ReadQueue";
    Access["ReadQuantity"] = "ReadQuantity";
    Access["ReadRunPending"] = "ReadRunPending";
    Access["ReadBypass"] = "ReadBypass";
    // Formulary
    Access["ReadMaster"] = "ReadMaster";
    Access["ReadFormulary"] = "ReadFormulary";
    Access["ReadAllFormulary"] = "ReadAllFormulary";
    Access["CreateFormulary"] = "CreateFormulary";
    Access["UpdateFormulary"] = "UpdateFormulary";
    Access["UpdatePrices"] = "UpdatePrices";
    Access["DestroyFormulary"] = "DestroyFormulary";
    // Inventory
    Access["ReadInventory"] = "ReadInventory";
    Access["ReadInventories"] = "ReadInventories";
    Access["ReadLots"] = "ReadLots";
    Access["UpdateLots"] = "UpdateLots";
    Access["ReadCycle"] = "ReadCycle";
    Access["UpdateCycle"] = "UpdateCycle";
    Access["UpdateInventory"] = "UpdateInventory";
    // Order
    Access["ReadOrder"] = "ReadOrder";
    Access["UpdateDistributors"] = "UpdateDistributors";
    Access["ReadOrderRules"] = "ReadOrderRules";
    Access["UpdateOrderRules"] = "UpdateOrderRules";
    Access["ReadTemplates"] = "ReadTemplates";
    Access["UpdateTemplates"] = "UpdateTemplates";
    Access["ReadOrderReview"] = "ReadOrderReview";
    Access["UpdateOrderApprover"] = "UpdateOrderApprover";
    Access["ReceivedPOAlert"] = "ReceivedPOAlert";
    // Pharmacies
    Access["CreatePharmacy"] = "CreatePharmacy";
    Access["ReadPharmacy"] = "ReadPharmacy";
    Access["ReadPharmacies"] = "ReadPharmacies";
    Access["ReadPharmacyAssets"] = "ReadPharmacyAssets";
    Access["UpdatePharmacy"] = "UpdatePharmacy";
    Access["DestroyPharmacy"] = "DestroyPharmacy";
    Access["ReadDistributors"] = "ReadDistributors";
    Access["ViewDisabledSites"] = "ViewDisabledSites";
    Access["EditPharmacies"] = "EditPharmacies";
    // Patients
    Access["CreatePatient"] = "CreatePatient";
    Access["ReadPatient"] = "ReadPatient";
    Access["ReadPatients"] = "ReadPatients";
    Access["UpdatePatients"] = "UpdatePatients";
    Access["DestroyPatients"] = "DestroyPatients";
    Access["UpdateWaterfall"] = "UpdateWaterfall";
    // Providers
    Access["CreateProvider"] = "CreateProvider";
    Access["ReadProvider"] = "ReadProvider";
    Access["ReadProviders"] = "ReadProviders";
    Access["ReadProviderAssets"] = "ReadProviderAssets";
    Access["UpdateProviders"] = "UpdateProviders";
    Access["DestroyProviders"] = "DestroyProviders";
    // Users
    Access["CreateUser"] = "CreateUser";
    Access["ReadUser"] = "ReadUser";
    Access["ReadUsers"] = "ReadUsers";
    Access["ReadUserAssets"] = "ReadUserAssets";
    Access["UpdateUser"] = "UpdateUser";
    Access["DestroyUser"] = "DestroyUser";
    Access["LogOutUser"] = "LogOutUser";
    Access["ViewGroupSelection"] = "ViewGroupSelection";
    // User Homepage
    Access["HomepageDashboard"] = "HomepageDashboard";
    Access["HomepageClaims"] = "HomepageClaims";
    Access["HomepageInventories"] = "HomepageInventories";
    Access["HomepageOrder"] = "HomepageOrder";
    Access["HomepagePrescribe"] = "HomepagePrescribe";
    Access["HomepageLabels"] = "HomepageLabels";
    Access["HomepageDispense"] = "HomepageDispense";
    Access["HomepageReports"] = "HomepageReports";
    Access["HomepageLedger"] = "HomepageLedger";
    Access["HomepageEob"] = "HomepageEob";
    Access["HomepageAssetApprovals"] = "HomepageAssetApprovals";
    Access["HomepageFinacials"] = "HomepageFinancials";
    // Reporting
    Access["ReadReports"] = "ReadReports";
    Access["ReadAuditTrail"] = "ReadAuditTrail";
    Access["ReadPatientsReport"] = "ReadPatientsReport";
    Access["ReadClaimAnalytics"] = "ReadClaimAnalytics";
    Access["ReadClaimsAudit"] = "ReadClaimsAudit";
    Access["ReadClinicReimb"] = "ReadClinicReimb";
    Access["ReadDispenseAnalytics"] = "ReadDispenseAnalytics";
    Access["ReadDistributorAnalytics"] = "ReadDistributorAnalytics";
    Access["ReadInsurancePayment"] = "ReadInsurancePayment";
    Access["ReadCycleCount"] = "ReadCycleCount";
    Access["ReadInventoryCount"] = "ReadInventoryCount";
    Access["ReadNetworkContacts"] = "ReadNetworkContacts";
    Access["ReadBulkPDFExport"] = "ReadBulkPDFExport";
    Access["ReadProductAudit"] = "ReadProductAudit";
    Access["ReadMailReport"] = "ReadMailReport";
    Access["ReadERXLogReport"] = "ReadERXLogReport";
    Access["ReadReversalsReport"] = "ReadReversalsReport";
    Access["ReadAssetsReport"] = "ReadAssetsReport";
    Access["ReadOrderAnalytics"] = "ReadOrderAnalytics";
    Access["ReadSalesUsageSummary"] = "ReadSalesUsageSummary";
    Access["ReadNegativeBalances"] = "ReadNegativeBalances";
    Access["ReadARAgingReport"] = "ReadARAgingReport";
    Access["ReadTransactionCounts"] = "ReadTransactionCounts";
    Access["ReadCertificationsReport"] = "ReadCertificationsReport";
    Access["ReadPharmacyReport"] = "ReadPharmacyReport";
    Access["ReadPatientPaymentReport"] = "ReadPatientPaymentReport";
    Access["ReadClaimErrorReport"] = "ReadClaimErrorReport";
    // Ledger
    Access["ReadLedger"] = "ReadLedger";
    // EOB
    Access["ReadEOB"] = "ReadEOB";
    // Billing
    Access["ReadBilling"] = "ReadBilling";
    // financials D-002.71
    Access["ReadFinancials"] = "ReadFinancials";
    Access["ReadPatientPayment"] = "ReadPatientPayment";
    Access["RefundPatientPayment"] = "RefundPatientPayment";
    Access["ManageSiteFinancial"] = "ManageSiteFinancial"; // pharmacies | Financial tab / merchant enrollment. E-092
})(Access = exports.Access || (exports.Access = {}));
var Category;
(function (Category) {
    Category["billing"] = "billing";
    Category["claims"] = "claims";
    Category["dashboard"] = "dashboard";
    Category["eob"] = "eob";
    Category["financials"] = "financials";
    Category["formulary"] = "formulary";
    Category["general"] = "general";
    Category["homepage"] = "homepage";
    Category["inventory"] = "inventory";
    Category["ledger"] = "ledger";
    Category["order"] = "order";
    Category["patients"] = "patients";
    Category["pharmacies"] = "pharmacies";
    Category["providers"] = "providers";
    Category["reports"] = "reports";
    Category["users"] = "users";
})(Category = exports.Category || (exports.Category = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/user-permission.ts
// module id = 1925
// module chunks = 0 1 2